import api from "./index"
import { format } from "date-fns"

export async function getDashboardStats(startDate, endDate) {
  if (!startDate || !endDate) {
    throw new Error("Start date and end date are required")
  }

  try {
    const start = format(new Date(startDate), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
    const end = format(new Date(endDate), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")

    const response = await api.get("/v1/dashboard", {
      params: {
        start_date: start,
        end_date: end,
      },
    })

    return response
  } catch (error) {
    console.error("Dashboard API Error:", error)
    throw error
  }
}
